function mapPollyVoice(language, gender) {
  switch (language) {
    case "English":
      if (gender === "male") {
        return window.gPolly?.Voices.ENGLISH_MALE ?? 4;
      } else {
        return window.gPolly?.Voices.ENGLISH_FEMALE ?? 3;
      }
    case "French":
      if (gender === "male") {
        return window.gPolly?.Voices.FRENCH_MALE ?? 6;
      } else {
        return window.gPolly?.Voices.FRENCH_FEMALE ?? 5;
      }
    case "German":
      if (gender === "male") {
        return window.gPolly?.Voices.GERMAN_MALE ?? 8;
      } else {
        return window.gPolly?.Voices.GERMAN_FEMALE ?? 7;
      }
    case "Spanish":
      if (gender === "male") {
        return window.gPolly?.Voices.SPANISH_MALE ?? 10;
      } else {
        return window.gPolly?.Voices.SPANISH_FEMALE ?? 9;
      }
    default:
      if (gender === "male") {
        return window.gPolly?.Voices.DANISH_MALE ?? 2;
      } else {
        return window.gPolly?.Voices.DANISH_FEMALE ?? 1;
      }
  }
}

export { mapPollyVoice };
//# sourceMappingURL=util.map-polly-voice.js.map
